import {VIcon} from 'vuetify/lib'
const arrow_hash = {
    asc: 'mdi-arrow-up',
    desc: 'mdi-arrow-down',
    nothing: 'mdi-arrow-up-down'
}
const d = ['nothing', 'asc', 'desc']
export default {
    props: {
        value: {
            type: String
        }
    },
    computed: {
        display_text() {
       
            if (!d.includes(this.value)) {
                return 'nothing'
            }
            return this.value
        }
    },
    render() {
        return <span style="cursor: pointer;" on={{
            click: () => {
                const index = (d.indexOf(this.display_text) + 1) % 3    
                this.$emit('change', d[index])
            }
        }}>
            <VIcon small color={this.display_text !== 'nothing' && 'primary' || ''}>
                {arrow_hash[this.display_text]}
            </VIcon>
        </span>
    }
}